import { render } from "./SignUpPlan.vue?vue&type=template&id=2e0038f8&scoped=true&ts=true"
import script from "./SignUpPlan.vue?vue&type=script&lang=ts"
export * from "./SignUpPlan.vue?vue&type=script&lang=ts"

import "./SignUpPlan.vue?vue&type=style&index=0&id=2e0038f8&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0038f8"]])

export default __exports__